import React from 'react'

export default function AnswerPercentagePageWrapper ({name, children, headerText}) {
  return (
    <div className={`new-page vertical-content answer-percentages-reports ${name.toLowerCase()}`}>
      <section className="page-header">
        <h3 className="page-title">{name} Answer Percentages</h3>
        <h3 className="school-class-info">{headerText}</h3>
      </section>
      <div>
        {children}
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/AnswerPercentage/AnswerPercentagePageWrapper.js